import ClaimListPage from "./claimList.container";

export default ClaimListPage;
